import type { SessionData } from '@/context/auth.context/auth.types';
import api from '@/lib/axiosConfig';

import type Rollbar from 'rollbar';

export async function getSession({ rollbar }: { rollbar: Rollbar }) {
  const url = 'session/?app=afvalprofiel';
  try {
    const res = await api.get<SessionData>(url);
    return res.data;
  } catch (error: unknown) {
    rollbar.error('Error fetching session', error as Rollbar.LogArgument, { url });
    throw error;
  }
}
